
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1b9047d53d9f9d22': `2) 點擊列表上的分享按鈕`,
's37a9e8aec5713460': `詳細資訊`,
's5c6aad7a7e4a1437': `3) 點擊加入主畫面`,
's6196153c4b0c1ea0': `安裝`,
's8d0173763d91830c': `以App的方式安裝到主畫面，提高用戶體驗以及操作便捷性`,
'sa5ef80b4bb9b39f8': `簡短資訊`,
'sc79fd7641eb9a975': `隱藏安裝流程`,
'scdaf4bbff76674c8': `將App加入主畫面`,
'sdca23702207fba73': `以App的方式安裝到裝置，提高用戶體驗以及操作便捷性`,
'sdfe23506a3b0cdc8': `1) 在Safari上瀏覽此網頁`,
    };
  